// v1.28.17 — Soft chime played when the twice-daily balance-check popup
// appears for the Super User. Same Web-Audio pattern as newUserChime.js
// (zero asset weight) with its own mute key so muting the SU nudge does
// NOT also silence slip-approve or online-user chimes.
let _ctx = null;
function ctx() {
    if (_ctx) return _ctx;
    try {
        const AC = window.AudioContext || window.webkitAudioContext;
        if (!AC) return null;
        _ctx = new AC();
    } catch { _ctx = null; }
    return _ctx;
}

const MUTE_KEY = "balance_notif_muted";
export const isBalanceChimeMuted = () => {
    try { return localStorage.getItem(MUTE_KEY) === "1"; } catch { return false; }
};
export const setBalanceChimeMuted = (v) => {
    try { localStorage.setItem(MUTE_KEY, v ? "1" : "0"); } catch { /* noop */ }
};

function tone(ac, freq, startAt, duration, gainPeak = 0.13) {
    const osc = ac.createOscillator();
    const gain = ac.createGain();
    osc.type = "sine";
    osc.frequency.setValueAtTime(freq, startAt);
    gain.gain.setValueAtTime(0.0001, startAt);
    gain.gain.exponentialRampToValueAtTime(gainPeak, startAt + 0.04);
    gain.gain.exponentialRampToValueAtTime(0.0001, startAt + duration);
    osc.connect(gain).connect(ac.destination);
    osc.start(startAt);
    osc.stop(startAt + duration + 0.02);
}

/** Soft three-note "attention" chime for the SU balance-check popup. */
export function playBalanceChime() {
    if (isBalanceChimeMuted()) return;
    try {
        if (window.matchMedia?.("(prefers-reduced-motion: reduce)").matches) return;
    } catch { /* noop */ }
    const ac = ctx();
    if (!ac) return;
    if (ac.state === "suspended") { try { ac.resume(); } catch { /* noop */ } }
    const now = ac.currentTime;
    // Warm ascending triad — C5 → E5 → G5. Slower and softer than the
    // approve chime so it reads as a gentle "check the app" nudge.
    tone(ac, 523, now,        0.28, 0.11);   // C5
    tone(ac, 659, now + 0.18, 0.30, 0.12);   // E5
    tone(ac, 784, now + 0.36, 0.42, 0.13);   // G5
}
